import api, { convertToISODateTime, handleApiError } from './client';

export const parentService = {
  getParent: async (userId) => {
    try {
      const response = await api.get(`/api/parents/${userId}`);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Get parent error:', error);
      return handleApiError(error, 'Errore nel caricamento dei dati del genitore');
    }
  },

  createParent: async (parentData) => {
    try {
      const payload = {
        userId: parentData.userId,
        firstName: parentData.firstName || null,
        lastName: parentData.lastName || null,
        email: parentData.email || null,
        phoneNumber: parentData.phoneNumber || null,
        fiscalCode: parentData.fiscalCode || null,
        dateOfBirth: convertToISODateTime(parentData.dateOfBirth),
        birthMunicipality: parentData.birthMunicipality || null,
        residenceMunicipality: parentData.residenceMunicipality || null,
        residenceProvince: parentData.residenceProvince || null,
        residencePostalCode: parentData.residencePostalCode || null,
        residenceStreet: parentData.residenceStreet || null,
      };

      const response = await api.post('/api/parents', payload);
      return {
        success: true,
        data: response.data,
        message: 'Dati genitore creati con successo',
      };
    } catch (error) {
      console.error('Create parent error:', error);
      return handleApiError(error, 'Errore nella creazione dei dati del genitore');
    }
  },

  updateParent: async (userId, parentData) => {
    try {
      const payload = {
        firstName: parentData.firstName || null,
        lastName: parentData.lastName || null,
        email: parentData.email || null,
        phoneNumber: parentData.phoneNumber || null,
        fiscalCode: parentData.fiscalCode || null,
        dateOfBirth: convertToISODateTime(parentData.dateOfBirth),
        birthMunicipality: parentData.birthMunicipality || null,
        residenceMunicipality: parentData.residenceMunicipality || null,
        residenceProvince: parentData.residenceProvince || null,
        residencePostalCode: parentData.residencePostalCode || null,
        residenceStreet: parentData.residenceStreet || null,
      };

      const response = await api.put(`/api/parents/${userId}`, payload);
      return {
        success: true,
        data: response.data,
        message: 'Dati genitore aggiornati con successo',
      };
    } catch (error) {
      console.error('Update parent error:', error);
      return handleApiError(error, "Errore nell'aggiornamento dei dati del genitore");
    }
  },
};

export default parentService;
